import { render } from "./CreateTag.vue?vue&type=template&id=88391780"
import script from "./CreateTag.vue?vue&type=script&lang=js"
export * from "./CreateTag.vue?vue&type=script&lang=js"
script.render = render

export default script